import Header from "./components/Header";
import Hero from "./components/Hero";
import IndexNav from "./components/IndexNav";
import Featured from "./components/Featured";
import EvidenceLibrary from "./components/EvidenceLibrary";
import Timeline from "./components/Timeline";
import Standard from "./components/Standard";
import Archive from "./components/Archive";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexNav />
        <Featured />
        <EvidenceLibrary />
        <Timeline />
        <Standard />
        <Archive />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}